import { Controller } from '@hotwired/stimulus';
import { conditionIcon } from '../lib/condition_icons';

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.connected = true;
    this.beforeMorph = this.preserveArtwork.bind(this);
    this.element.addEventListener('turbo:before-morph-element', this.beforeMorph);
    this.load();
  }

  disconnect() {
    this.element.removeEventListener('turbo:before-morph-element', this.beforeMorph);
    this.connected = false;
    this.request = null;
  }

  urlValueChanged() {
    if (this.connected) this.load();
  }

  preserveArtwork(event) {
    if (event.target !== this.element || !this.loadedUrl) return;
    if (event.detail.newElement.getAttribute('data-condition-icon-url-value') === this.loadedUrl) {
      // The server sends a fallback. Keep the SVG when its version is unchanged.
      event.preventDefault();
    }
  }

  async load() {
    const request = this.request = {};
    const url = this.urlValue;
    this.loadedUrl = null;
    try {
      const icon = await conditionIcon(url);
      if (this.connected && this.request === request) {
        this.element.replaceChildren(icon);
        this.loadedUrl = url;
      }
    } catch {
      // Leave the Font Awesome fallback usable if offline or access was revoked.
    }
  }
}
